export const generateHash = async (data: string): Promise<string> => {
  const buffer = await crypto.subtle.digest(
    'sha-1',
    new TextEncoder().encode(data),
  );
  return Array.from(new Uint8Array(buffer))
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
};
